/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { variation } from 'ember-launch-darkly';

export default class NewChatComponent extends Component {
  @service twoWayChat;
  @service session;
  @service whatsapp;

  @tracked selectedChannel = 'WHATSAPP';
  @tracked showSelectChannelModal = false;
  @tracked selectedClient = null;

  @action
  onClientChoose(client) {
    const { isTwoWayEnabled } = this.twoWayChat;
    const { hasSuccessfulConnection } = this.whatsapp;

    this.selectedClient = client;

    if (variation('release-marketing-whatsapp-integration-p-10')) {
      if (isTwoWayEnabled && hasSuccessfulConnection) {
        this.showSelectChannelModal = true;
        return;
      }
    }

    this.twoWayChat.selectClient(this.selectedClient, {
      channel: isTwoWayEnabled ? 'SMS' : 'WHATSAPP',
    });
    this.twoWayChat.setNextScreen(
      isTwoWayEnabled ? 'client-chat' : 'templates-list'
    );
    this.selectedClient = null;
  }

  @action
  onCloseSelectChannelModal() {
    this.showSelectChannelModal = false;
    this.selectedClient = null;
  }

  @action
  onStartChat() {
    this.twoWayChat.selectClient(this.selectedClient, {
      channel: this.selectedChannel,
    });
    this.twoWayChat.setNextScreen(
      this.selectedChannel === 'WHATSAPP' ? 'templates-list' : 'client-chat'
    );
    this.selectedClient = null;
  }
}
